/*************************************************************************
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

const makeCancellablePromise = (promise => {
    let isCancelled = false;
    let retVal = promise;

    if (!retVal) {
        retVal = Promise.reject();
    }

    const wrappedPromise = new Promise((resolve, reject) => {
        retVal.then(data => !isCancelled && resolve(data))
            .catch(error => !isCancelled && reject(error));
    });

    return {
        promise: wrappedPromise,
        cancel: () => {
            isCancelled = true;
        },
    };
});

export default makeCancellablePromise;
